import Seo from "../components/generic/Seo";
import ServicesModule from "../components/service/ServicesModule";

const objSeo = {
  title:
    "Springevening Private Limited -Custom App Development for Web & Mobile",
  keywords:
    "startup, Software company, Soochi ERP, HappyNenapu, Flipbook, Brand reflection,Maximizing brand reach,SEO optimization,Empowering developers, Training, Internship, Bagalkot, BEC, sedamkar, North Karnataka",
  pathSlug: "/services",
  description:
    "End-to-End Custom App Development for Web & Mobile Expert Flutter and web solutions, built for you",
};

const Services = () => {
  return (
    <>
      <Seo data={objSeo} />
      <ServicesModule />;
    </>
  );
};

export default Services;
